import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";

import {
  Actions,
} from "../../styles";

import { setFeaturedPost } from "../../../../../../../store/actions/post";
import { Post } from "../../../../../../../types/post";

import chainIcon from "../../../../../../../assets/icons/chain-regular.svg";
import postEditIcon from "../../../../../../../assets/icons/post-edit-icon.svg";
import postPinCheckedIcon from "../../../../../../../assets/icons/post-pin-checked-icon.svg";
import postPinUncheckedIcon from "../../../../../../../assets/icons/post-pin-unchecked-icon.svg";
import chevronDownIcon from "../../../../../../../assets/icons/chevron-down.svg";
import {
  MenuWrapper,
  MenuToggle,
  MenuToggleIcon,
  MenuList,
  MenuListItem,
  MenuItemButton,
  MenuItemLink,
  MenuItemIcon,
} from "./styles";

interface CardArticleActionsProps {
  post: Post;
  ownGroup: boolean;
  isMine: boolean;
  groupInformation: any;
  canShowPin: boolean;
  onUnpinIt?: React.Dispatch<React.SetStateAction<Post | undefined>>;
  className?: string;
}

const CardArticleActions = ({
  post,
  ownGroup,
  isMine,
  groupInformation,
  canShowPin,
  onUnpinIt,
  className,
}: CardArticleActionsProps) => {
  const dispatch = useDispatch();
  const menuRef = useRef<HTMLDivElement | null>(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const canManagePost = ownGroup || isMine;

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!canManagePost) {
      setIsMenuOpen(false);
    }
  }, [canManagePost]);

  if (!canManagePost) {
    return null;
  }

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleTogglePinned = () => {
    dispatch(
      setFeaturedPost({
        idPost: post?.id,
        pinned: !post?.pinned,
      })
    );

    if (onUnpinIt) {
      onUnpinIt({
        ...post,
        pinned: !post?.pinned,
      });
    }

    closeMenu();
  };

  const handleCopyLink = async () => {
    const link = `${process.env.REACT_APP_SITE_BASE_URL}/group/${groupInformation?.id}/p/${post.id}`;

    try {
      await navigator.clipboard.writeText(link);
    } catch (error) {
      console.error("No se pudo copiar el enlace del artículo", error);
    }

    closeMenu();
  };

  const handleEditClick = () => {
    closeMenu();
  };

  const baseDashboardPath = groupInformation?.group_type === "free_experience"
    ? "community/events"
    : groupInformation?.group_type;

  const pinLabel = post?.pinned ? "Quitar destacado" : "Destacar";

  return (
    <Actions className={className}>
      <MenuWrapper ref={menuRef}>
        <MenuToggle
          type="button"
          aria-haspopup="true"
          aria-expanded={isMenuOpen}
          onClick={toggleMenu}
        >
          Acciones <MenuToggleIcon icon={chevronDownIcon} color="currentColor" size="13px" isOpen={isMenuOpen} />
        </MenuToggle>

        {isMenuOpen && (
          <MenuList role="menu">
            {canShowPin && (
              <MenuListItem>
                <MenuItemButton type="button" onClick={handleTogglePinned} role="menuitem">
                  <MenuItemIcon
                    icon={post?.pinned ? postPinCheckedIcon : postPinUncheckedIcon}
                    color="currentColor"
                    size="16px"
                  />
                  {pinLabel}
                </MenuItemButton>
              </MenuListItem>
            )}

            <MenuListItem>
              <MenuItemButton type="button" onClick={handleCopyLink} role="menuitem">
                <MenuItemIcon icon={chainIcon} color="currentColor" size="12px" />
                Copiar enlace
              </MenuItemButton>
            </MenuListItem>

            <MenuListItem>
              <MenuItemLink
                to={`/dashboard/${baseDashboardPath}/${groupInformation?.id}/posts/v2/${post.id}`}
                onClick={handleEditClick}
                role="menuitem"
              >
                <MenuItemIcon icon={postEditIcon} color="currentColor" size="14px" />
                Editar
              </MenuItemLink>
            </MenuListItem>
          </MenuList>
        )}
      </MenuWrapper>
    </Actions>
  );
};

export default CardArticleActions;

